import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import ActivityCategory from '../../entities/activityCategory';
import ActivityType from '../../entities/activityType';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteActivityCategory(): boolean {
return true;
}
export function collectActivityCategoryDeleteImpact(activityCategory: ActivityCategory, context: DeleteImpactContext): void {
const key = 'activityCategory:' + activityCategory.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const activityTypeActivityCategoryIdImpact = workingRows<ActivityType>('activityType', findAll<ActivityType>('activityTypes')).filter(activityTypeRef => activityTypeRef.activityCategoryId === activityCategory.id);
activityTypeActivityCategoryIdImpact.forEach(activityTypeRef => addDeleteImpact(context, 'activityType:' + activityTypeRef.id, 'activityTypes'));}
export function deleteImpactActivityCategory(activityCategory: ActivityCategory): DeleteImpact {
const context = deleteImpactContext();
collectActivityCategoryDeleteImpact(activityCategory, context);
return deleteImpactCounts(context);
}
export function deleteActivityCategory(activityCategory: ActivityCategory, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteActivityCategory()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectActivityCategoryDeleteImpact(activityCategory, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || activityCategory.id};
}
const key = 'activityCategory:' + activityCategory.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<ActivityType>('activityType', [...store.getState().activityTypes.getMappingFor('activityCategoryId', activityCategory.id)]).filter(activityTypeTemp => activityTypeTemp.activityCategoryId === activityCategory.id).forEach(activityTypeTemp => {
const _activityType = ((_work.get('activityType:' + activityTypeTemp.id) ?? activityTypeTemp) as ActivityType).clone();
if (_activityType.status === 'D') return;
_activityType.status = 'U';
_activityType.addedOn = newHRTimestamp();
_activityType.addedBy = getCurrentUserId();
_activityType.importSource = targetImportSource;
_activityType.importId = mergeId;
if (_activityType.activityCategoryId === activityCategory.id) {
_activityType.activityCategoryId = null;

}
_work.set('activityType:' + _activityType.id, _activityType);
dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType), 'activityType:' + _activityType.id);
});
const deleted = activityCategory.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.ActivityCategoryActions.removeActivityCategoryQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceActivityCategory(activityCategory: ActivityCategory, replaceWith: ActivityCategory, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = activityCategory.id;}
const _work = workingSet();
workingRows<ActivityType>('activityType', [...store.getState().activityTypes.getMappingFor('activityCategoryId', activityCategory.id)]).filter(activityTypeTemp => activityTypeTemp.activityCategoryId === activityCategory.id).forEach(activityTypeTemp => {
const _activityType = ((_work.get('activityType:' + activityTypeTemp.id) ?? activityTypeTemp) as ActivityType).clone();
if (_activityType.status === 'D') return;
_activityType.status = 'U';
_activityType.addedOn = newHRTimestamp();
_activityType.addedBy = getCurrentUserId();
_activityType.importSource = targetImportSource;
_activityType.importId = mergeId;
if (_activityType.activityCategoryId === activityCategory.id) {
_activityType.activityCategoryId = replaceWith.id;

}
_work.set('activityType:' + _activityType.id, _activityType);
store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
});



return activityCategory;
}
